import frFR from "./fr-FR.json";
import enGB from "./en-GB.json";

export default {
  fr: frFR,
  "fr-FR": frFR,
  "fr-BE": frFR,
  "fr-CA": frFR,
  "fr-LU": frFR,
  "fr-CH": frFR,
  en: enGB,
  "en-GB": enGB,
};
